import type { SkillResponse } from './types';

const TRANSACTION_TYPE_LABELS: Record<string, string> = {
  PURCHASE: 'Purchase',
  CONSUMPTION: 'Consumption',
  BONUS: 'Bonus',
  REFUND: 'Refund',
  SUBSCRIPTION: 'Subscription Credit',
  ADMIN_GRANT: 'Admin Grant',
  ADMIN_DEBIT: 'Admin Debit',
  MIGRATED_GRANT: 'Migrated Grant',
};

export function formatTransactionType(type: string): string {
  return (
    TRANSACTION_TYPE_LABELS[type] ??
    type.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase())
  );
}

/** The server keeps an expired grant `ACTIVE` and reports it as not enabled. */
export function formatSkillStatus(
  skill: Pick<SkillResponse, 'status' | 'enabled' | 'expiresAt'>,
): string {
  if (skill.status === 'ACTIVE' && !skill.enabled && skill.expiresAt) return 'EXPIRED';
  return skill.status ?? '—';
}
